export enum DistrictDocumentType {
    AGENDA = 'Agenda',
    CONTRACT = 'Contract'
}
